import { IRBACConfig } from 'easy-rbac-sync/src/rbac'
import RBAC from 'easy-rbac-sync'

/* eslint-disable */
const roleMap: IRBACConfig = {
  end_user_random: {
    can: []
  },
  end_user_patient: {
    can: []
  },
  end_user_family_member: {
    can: [
      'visit_list:read',
      'patients:read',
      'dashboard:read'
    ]
  },
  end_user_nurse: {
    can: [
      'visit_list:read',
      'patients:read',
      'dashboard:read'
    ]
  },
  end_user_home_nurse: {
    can: [
      'visit_list:read',
      'patients:read',
      'dashboard:read'
    ]
  },
  content_editor: {
    can: [
      // 'dashboard:*',
      'procedure:*',
      'role:read',
      'category:*',
      'learning_object:*'
    ]
  },
  project_admin: {
    can: []
  },
  department_admin: {
    inherits: ['content_editor', 'project_admin'],
    can: [
      'user:read',
      'user:reinvite',
      'user:invite',
      'users:department',
      'dashboard:department',
      'patients:department',
      'procedure:department',
      'patient:department',
      'visit_list:nurse',
      'study:create',
      'study:read',
      'device:read',
      'device:create',
      'nurse_location:department',
    ]
  },
  institutional_admin: {
    inherits: ['department_admin'],
    can: [
      'user:read',
      'user:reinvite',
      'user:invite',
      'department:department',
      'dashboard:department',
      'procedure:department',
      'users:department',
      'visit_list:nurse',
      'patients:*',
      'patient:*',
      'nurse_location:*',
      'study:department',
      'study:create',
      'study:read',
      'devices:*',
      'device:*',
      'import:procedures'
    ]
  },
  super_admin: {
    inherits: ['institutional_admin'],
    can: [
      'institutions:institutions',
      'user:*',
      'study:*'
    ]
  }
}
/* eslint-enable */

const rbac = new RBAC(roleMap)

export { rbac }
